module.exports = __webpack_public_path__ + "static/media/photo.bbfa557f.jpg";